var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShovel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.64 -212.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-318.792,212.63l-3.624,3.593,2.123,2.1-.98.98-.467-.467-4.9,4.853,2.971,2.94,4.892-4.853-.451-.443.98-.98,2.108,2.092,3.5-3.477V212.63Zm-1.291,9.186-3.586,3.554-1.688-1.68,3.586-3.554.031-.031,1.688,1.672Zm1.2-2.092-.98.98-.778-.77.98-.98.638-.63,1.361-1.346.77.77-1.353,1.346Zm5.359-1.128-2.613,2.582-1.47-1.454,2-1.976-2.053-2.03-1.991,1.976-1.486-1.47,2.722-2.707h4.892Z",
    transform: "translate(0 0)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShovel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shovel.000e9bc31f03eedfcead5ba5616605be.svg";